import colors from "@/styles/colors";

export default function ArrowUpIcon(props: React.SVGProps<SVGSVGElement>) {
    const { color = colors.blueDark } = props;
    return (
        <svg width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M11 6L6 1L1 6" stroke={color} strokeWidth="1.5" strokeLinecap="round" />
        </svg>
    )
}